<script>
  export let min;
  export let max;
  export let min_var_name;
  export let max_var_name;
  export let default_min;
  export let default_max;
  export let update;
  export let label;
  let values = [default_min,default_max];
  let prev_values = [...values];
  import RangeSlider from "svelte-range-slider-pips";
</script>

{label}

<RangeSlider
  min={min}
  max={max}
  pips
  range
  float
  first='label'
  last='label'
  bind:values={values}
  on:stop="{() => {
      if (values[0] != prev_values[0]) {
        update(min_var_name, values[0]);
      }
      if (values[1] != prev_values[1])  {
        update(max_var_name, values[1]);
      }
      prev_values = [...values];
  }}"
/>
